var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarita1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172.966,
    height: 100.359,
    viewBox: "0 0 172.966 100.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(-111.474 -280.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62",
    transform: "translate(139.501 280.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98",
    "data-name": "Trazado 98",
    d: "M150.417,308.316a18.1,18.1,0,0,0-2.307-6.039,18.9,18.9,0,0,0-3.727-4.775,24.624,24.624,0,0,0-7.245-3.958c-3.516-1.44-8.193.309-10.716,2.832a11.307,11.307,0,0,0-2.832,10.716c1.444,6.775,6,14.123,12.968,16.23,4.269,1.288,10.612-.763,12.555-5.11A14.962,14.962,0,0,0,150.417,308.316Z",
    transform: "translate(-123.272 -263.53)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99",
    "data-name": "Trazado 99",
    d: "M181.823,295.9a18.2,18.2,0,0,0-2.307-6.041,18.852,18.852,0,0,0-3.727-4.772,24.59,24.59,0,0,0-7.248-3.96c-3.513-1.44-8.191.309-10.716,2.834a11.309,11.309,0,0,0-2.832,10.714c1.447,6.777,6,14.123,12.971,16.23,4.266,1.288,10.609-.763,12.552-5.11A14.944,14.944,0,0,0,181.823,295.9Z",
    transform: "translate(-80.073 -280.609)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61",
    transform: "translate(10.533 32.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    "data-name": "Trazado 100",
    d: "M171.241,298.522l-.017,0c.4.242.482.264.382.192-.09-.045-.178-.093-.264-.14A.983.983,0,0,0,171.241,298.522Z",
    transform: "translate(-67.844 -288.583)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_101",
    "data-name": "Trazado 101",
    d: "M234.309,295.715a17.67,17.67,0,0,0-11.628-.739A12.807,12.807,0,0,0,216.821,298c-1.482,1.47-3.506,3.948-2.765,6.217a2.583,2.583,0,0,0,1.832,1.829,5.265,5.265,0,0,0,2.832-.411,13.951,13.951,0,0,0,1.3-.594,4.449,4.449,0,0,0,.625-.238c.335-.109.677-.192,1.01-.3.052,1.665.223,3.278.2,4.461-.271,17.928-10.452,33.408-27.236,40.168a54.066,54.066,0,0,1-29.958,2.625,60.862,60.862,0,0,1-15.306-4.965,84.158,84.158,0,0,1-10.027-6.155c.031-.05.055-.1.088-.15a11.316,11.316,0,0,1,1.188-1.2c.178-.116.344-.252.532-.356a13.714,13.714,0,0,0,2.041-1.451,4.757,4.757,0,0,0-3.347-8.079c-4.533.183-8.609,4.274-10.386,8.224a18.666,18.666,0,0,0-1.725,6.839,13.817,13.817,0,0,0,.268,3.459,6.608,6.608,0,0,0,2.444,3.711,4.527,4.527,0,0,0,4.236,1.119,4.3,4.3,0,0,0,3.041-3.041c.071-.371.183-.725.283-1.086,1.644,1.178,3.333,2.285,4.946,3.3a71.993,71.993,0,0,0,12.826,6.317,57.494,57.494,0,0,0,27.83,3.38c18.358-2.364,35.835-13.194,43.544-30.445,3.708-8.3,5.775-17.888,3.905-26.927l.04.014-.043-.026v-.009c.052.033.107.057.162.088a1.4,1.4,0,0,1,.264.14,8.784,8.784,0,0,0,2.7.741,4.041,4.041,0,0,0,4.675-3.9C238.88,298.594,236.55,296.736,234.309,295.715Z",
    transform: "translate(-127.706 -294.335)",
    fill: "#222221"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_102",
    "data-name": "Trazado 102",
    d: "M131.545,314.215a5.188,5.188,0,0,0-1.126-3.176,5,5,0,0,0-2.1-1.615,5.571,5.571,0,0,0-2.585-.444,4.851,4.851,0,0,0-1.656.052,4.122,4.122,0,0,0-1.321.306c-.3.128-.606.257-.91.382a22.207,22.207,0,0,0-2.577,1.128l-1,.587a17.771,17.771,0,0,0-3.288,2.516,9.745,9.745,0,0,0-3.243,4.825,7.535,7.535,0,0,0,0,3.991,5.632,5.632,0,0,0,1.342,2.554,5.692,5.692,0,0,0,2.107,1.934,7.446,7.446,0,0,0,3.789,1.024c.72-.085,1.44-.183,2.159-.287a3.09,3.09,0,0,0,1.078-.423,5.766,5.766,0,0,0,2.478-1.592c.1-.078.188-.157.28-.235l.841-.7c.3-.254.613-.5.91-.763a15.636,15.636,0,0,0,1.81-2.333,16.467,16.467,0,0,0,1.278-1.862c.169-.3.337-.606.5-.91.086-.152.171-.3.252-.454a6.958,6.958,0,0,0,.827-3.516A4.62,4.62,0,0,0,131.545,314.215Z",
    transform: "translate(0 38.96)",
    fill: "#ba0008",
    opacity: 0.328
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63",
    transform: "translate(262.265 287.697)",
    opacity: 0.328
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_103",
    "data-name": "Trazado 103",
    d: "M179.157,284.668c.52-.223,1.043-.435,1.561-.658l.114-.047Z",
    transform: "translate(-169.163 -283.085)",
    fill: "#ba0008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104",
    "data-name": "Trazado 104",
    d: "M197.067,289.116a6.226,6.226,0,0,0-1.235-2.943,2.178,2.178,0,0,0-1.031-1.694,1.878,1.878,0,0,0-.829-.152c-.247.033-.23.031.057-.01l-.366.05a6.275,6.275,0,0,0-2.321-.663,6.931,6.931,0,0,0-3.563.278c-.432.162-.85.354-1.273.535-.663.278-1.321.568-1.981.858-2.4.96-5.183,1.748-7.039,3.6l1.2-.929a10.767,10.767,0,0,0-2.093,1.846,5.939,5.939,0,0,0-.962,1.8,3.477,3.477,0,0,0-.456,1,3.234,3.234,0,0,0,.4,3.181,6.445,6.445,0,0,0,1.174,1.15c1.568,1.858,4.35,2.276,6.694,2.207a24.545,24.545,0,0,0,4.426-.544c3.7-.793,8.3-2.87,9.01-6.932A6.541,6.541,0,0,0,197.067,289.116Z",
    transform: "translate(-174.95 -283.593)",
    fill: "#ba0008"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarita1);
export default __webpack_public_path__ + "static/media/carita1.94ed5fb0287126928096693f34041b1c.svg";
export { ForwardRef as ReactComponent };